import React from 'react'
import LandingPage from 'components/landing/landingPage'

export default function LandingPageContainer() {
  return (
    <React.Fragment>
        <LandingPage />
    </React.Fragment>

  )
}
